import { useHandler } from "@redotech/react-util/hook";
import { AddOrderTagsActionStep } from "@redotech/redo-flows-common/oms/actions";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";
import { PartialWithRequiredType } from ".";

export const OrderTagInput = memo(function OrderTagInput({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<AddOrderTagsActionStep>;
  setStep: (step: PartialWithRequiredType<AddOrderTagsActionStep>) => void;
}) {
  const { t } = useTranslation();
  const [input, setInput] = useState<string>("");

  const tags = useMemo(
    () =>
      (step.tags ?? []).map((name) => ({ text: name, color: "gray" as const })),
    [step.tags],
  );

  const setTags = useHandler((names: string[]) => {
    const unique: string[] = [];
    for (const name of names) {
      const trimmed = name.trim();
      if (trimmed && !unique.includes(trimmed)) {
        unique.push(trimmed);
      }
    }
    setStep({ ...step, tags: unique });
  });

  return (
    <RedoTagInputField
      delimiters={["newline", "comma"]}
      inputValue={input}
      placeholder={t("Type a tag and press Enter")}
      setInputValue={setInput}
      setTags={setTags}
      tags={tags}
    />
  );
});
